import React from "react";
import { Box, Typography, Divider } from "@material-ui/core";
import './PrePaymentFeeBreakdown.scss';
import { LoanData } from "../../../../loan-details/model/LoanData";
import { FeeOptionKey } from "../../../../loan-details/component/FeeSelector";

interface Props {
    loan: LoanData;
    selectedFees: FeeOptionKey[];
    availableFeeForBreakdown?: Array<{key: FeeOptionKey, label: string, amount: string}>;
    shouldShowBreakdownForNoSelection?: boolean;
}

export class PrePaymentFeeBreakdown extends React.Component<Props> {

    private getFeeItems = () => {
        const items: Array<{label: string, amount: string}> = [];

        if (this.props.selectedFees && this.props.selectedFees.length > 0) {
            if (this.props.selectedFees.includes("APPRAISAL")) {
                items.push({
                    label: "Appraisal Fee",
                    amount: this.props.loan.appraisalFee
                });
            }

            if (this.props.selectedFees.includes("CREDIT_REPORT")) {
                items.push({
                    label: "Credit Report Fee",
                    amount: this.props.loan.creditReportFee
                });
            }
        }
        else if (this.props.availableFeeForBreakdown && this.props.availableFeeForBreakdown.length > 0) {
            this.props.availableFeeForBreakdown.forEach(fee => {
                items.push({
                    label: fee.label,
                    amount: fee.amount
                });
            });
        }

        return items;
    };

    private getTotalAmount = () => {
        let total = 0;

        if (this.props.selectedFees && this.props.selectedFees.length > 0) {
            if (this.props.selectedFees.includes("APPRAISAL")) {
                total += parseFloat(this.props.loan.appraisalFee.replace(/[$,]/g, ''));
            }

            if (this.props.selectedFees.includes("CREDIT_REPORT")) {
                total += parseFloat(this.props.loan.creditReportFee.replace(/[$,]/g, ''));
            }
        }
        else if (this.props.availableFeeForBreakdown && this.props.availableFeeForBreakdown.length > 0) {
            this.props.availableFeeForBreakdown.forEach(fee => {
                total += parseFloat(fee.amount.replace(/[$,]/g, ''));
            });
        }

        return total.toFixed(2);
    };

    render() {
        const feeItems = this.getFeeItems();
        const totalAmount = this.getTotalAmount();
        const isMultipleFees = feeItems.length > 1;

        return (
            <Box className="fee-breakdown">
                <Typography variant="h6" gutterBottom>
                    💳 {isMultipleFees ? 'Payment Breakdown' : 'Selected Fee'}
                </Typography>

                {feeItems.map((item, index) => (
                    <Box key={index} className="fee-item">
                        <Typography variant="body1" className="fee-label">
                            {item.label}
                        </Typography>
                        <Typography variant="body1" className="fee-amount">
                            {item.amount}
                        </Typography>
                    </Box>
                ))}

                <Divider />

                <Box className="total-section">
                    <Typography variant="h6" className="total-label">
                        {isMultipleFees ? 'Total Amount' : 'Amount'}
                    </Typography>
                    <Typography variant="h6" className="total-amount">
                        ${totalAmount}
                    </Typography>
                </Box>
            </Box>
        );
    }
}
